var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReturns(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 21.521V10.3645C28.9995 9.87538 28.8709 9.395 28.6271 8.97155C28.3834 8.5481 28.033 8.19646 27.6111 7.9519L17.8889 2.37367C17.4666 2.12887 16.9876 2 16.5 2C16.0124 2 15.5334 2.12887 15.1111 2.37367L5.38889 7.9519C4.96703 8.19646 4.61664 8.5481 4.37286 8.97155C4.12909 9.395 4.0005 9.87538 4 10.3645V21.521C4.0005 22.0101 4.12909 22.4904 4.37286 22.9139C4.61664 23.3373 4.96703 23.689 5.38889 23.9335L15.1111 29.5118C15.5334 29.7566 16.0124 29.8854 16.5 29.8854C16.9876 29.8854 17.4666 29.7566 17.8889 29.5118L27.6111 23.9335C28.033 23.689 28.3834 23.3373 28.6271 22.9139C28.8709 22.4904 28.9995 22.0101 29 21.521Z",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.375 8.91406L16.5 15.9566L28.625 8.91406",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 30V15.9429",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReturns);
export default __webpack_public_path__ + "static/media/Returns.fb34d5ff920cfcbb013df0cb54cc0903.svg";
export { ForwardRef as ReactComponent };